import * as React from 'react'

const Edit = (props: { className?: string }) => (
  <svg
    className={props.className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.48001 10.4823L5.45131 13.4534C5.58485 13.5869 5.78517 13.5869 5.91871 13.4534L13.3303 6.00892C13.4638 5.87539 13.4638 5.67509 13.3303 5.54155L10.3924 2.60382C10.2588 2.47029 10.0585 2.47029 9.92496 2.60382L2.48001 10.0483C2.34647 10.1818 2.34647 10.3821 2.48001 10.4823ZM11.3594 1.23518C11.2259 1.36872 11.2259 1.56902 11.3594 1.70255L14.2973 4.64028C14.4309 4.77382 14.6312 4.77382 14.7647 4.64028L15.5994 3.8057C16.1335 3.30495 16.1335 2.50375 15.5994 1.96962L14.0303 0.4006C13.4961 -0.133533 12.6615 -0.133533 12.1273 0.4006L11.3594 1.23518ZM0.00937292 15.4231C-0.0573979 15.7569 0.243071 16.0574 0.576925 15.9906L4.21594 15.1227C4.34948 15.0893 4.44964 15.0225 4.51641 14.9557L4.58318 14.889C4.64995 14.8222 4.68333 14.5885 4.54979 14.455L1.5451 11.4505C1.41156 11.317 1.17786 11.3503 1.11109 11.4171L1.04432 11.4839C0.944165 11.584 0.910779 11.6842 0.877394 11.7843L0.00937292 15.4231Z'
      fill='#405264'
    />
    <mask id='mask0' maskUnits='userSpaceOnUse' x='0' y='0' width='16' height='16'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.48001 10.4823L5.45131 13.4534C5.58485 13.5869 5.78517 13.5869 5.91871 13.4534L13.3303 6.00892C13.4638 5.87539 13.4638 5.67509 13.3303 5.54155L10.3924 2.60382C10.2588 2.47029 10.0585 2.47029 9.92496 2.60382L2.48001 10.0483C2.34647 10.1818 2.34647 10.3821 2.48001 10.4823ZM11.3594 1.23518C11.2259 1.36872 11.2259 1.56902 11.3594 1.70255L14.2973 4.64028C14.4309 4.77382 14.6312 4.77382 14.7647 4.64028L15.5994 3.8057C16.1335 3.30495 16.1335 2.50375 15.5994 1.96962L14.0303 0.4006C13.4961 -0.133533 12.6615 -0.133533 12.1273 0.4006L11.3594 1.23518ZM0.00937292 15.4231C-0.0573979 15.7569 0.243071 16.0574 0.576925 15.9906L4.21594 15.1227C4.34948 15.0893 4.44964 15.0225 4.51641 14.9557L4.58318 14.889C4.64995 14.8222 4.68333 14.5885 4.54979 14.455L1.5451 11.4505C1.41156 11.317 1.17786 11.3503 1.11109 11.4171L1.04432 11.4839C0.944165 11.584 0.910779 11.6842 0.877394 11.7843L0.00937292 15.4231Z'
        fill='#fff'
      />
    </mask>
  </svg>
)

export default Edit



// WEBPACK FOOTER //
// ./src/components/icons/drivers/Edit.tsx